import type { ReportCreate, ReportType } from "./api";

export function buildPayload({
  stationId,
  type,
  duration,
  carsAhead,
  now = new Date(),
}: {
  stationId: string;
  type: ReportType;
  duration: number;
  carsAhead: number;
  now?: Date;
}): ReportCreate {
  const payload: ReportCreate = {
    station_id: stationId,
    report_type: type,
  };
  if (type === "charging") {
    payload.expected_end_time = new Date(now.getTime() + duration * 60_000).toISOString();
  }
  if (type === "waiting") {
    payload.user_count_waiting = carsAhead;
  }
  return payload;
}
